export default "__VITE_ASSET__60e09724__"